export const EDITABLE_OVERLAY_FIELDS = [
  'ecommerce.rivirmarketingdescription',
  'header.manufacturernameheader',
  'header.vendoritemnumber',
  'header.unitcount',
  'header.productstyle',
  'header.productflavor',
  'header.productscent',
  'marketinginformation.marketinginformation.tradeitemmarketingmessage.value',
  'marketinginformation.marketinginformation.tradeitemmarketingmessage.languagecode',
  'marketinginformation.marketinginformation.educationalfocusdescription.languagecode',
  'marketinginformation.marketinginformation.educationalfocusdescription.value',
  'marketinginformation.marketinginformation.marketingcampaign.tastingnotes.value',
  'marketinginformation.marketinginformation.shorttradeitemmarketingmessage.value',
  'marketinginformation.marketinginformation.tradeitemfeaturebenefit.value',
  'productname',
  'productdescription',
  'primarysizeuom',
  'primarysize',
  'height',
  'depth',
  'width',
  'weight',
  'weightuom',
  'dimensionuom',
  'tradeitemdescription.tradeitemdescriptioninformation.tradeitemdescription.value',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.subbrand',
  'tradeitemdescription.tradeitemdescriptioninformation.descriptionshort.value',
  'tradeitemdescription.tradeitemdescriptioninformation.functionalname.value',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.languagespecificbrandname.value',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.languagespecificbrandname.languagecode',
  'tradeitemdescription.tradeitemdescriptioninformation.brandnameinformation.brandname',
  'tradeitemmeasurements.tradeitemmeasurements.netcontent.measurementunitcode',
  'tradeitemmeasurements.tradeitemmeasurements.netcontent.value',
  'tradeitemmeasurements.tradeitemmeasurements.netcontentstatement.value',
  'tradeitemmeasurements.tradeitemmeasurements.netcontentstatement.languagecode',
  'tradeitemmeasurements.tradeitemmeasurements.height.value',
  'tradeitemmeasurements.tradeitemmeasurements.depth.value',
  'tradeitemmeasurements.tradeitemmeasurements.width.value',
  'tradeitemmeasurements.tradeitemmeasurements.tradeitemweight.grossweight.value',
  'tradeitemmeasurements.tradeitemmeasurements.depth.measurementunitcode',
  'tradeitemmeasurements.tradeitemmeasurements.height.measurementunitcode',
  'tradeitemmeasurements.tradeitemmeasurements.width.measurementunitcode',
];
